import { useState } from "react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

export default function WordCounter() {
  const [text, setText] = useState("");

  const countWords = (txt) => {
    return txt.trim().split(/\s+/).filter(Boolean).length;
  };

  const countChars = (txt) => txt.length;
  const countCharsNoSpaces = (txt) => txt.replace(/\s/g, '').length;
  const countSentences = (txt) => txt.split(/[.!?]+/).filter(Boolean).length;
  const countParagraphs = (txt) => txt.split(/\n+/).filter(Boolean).length;

  return (
    <>
      <Helmet>
        <title>Word Counter Tool - Free Online Text Analyzer</title>
        <meta
          name="description"
          content="Count words, characters, sentences, and paragraphs instantly with this free online Word Counter tool. Perfect for writers, students, and SEO experts."
        />
        <meta
          name="keywords"
          content="word counter tool, word count, character counter, sentence counter, free online text analyzer, word counter for writing, seo tools"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/word-counter" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>Word Counter Tool</h2>
          <p>Paste or type your text below to get a real-time word count and more.</p>

          <textarea
            className="form-control"
            rows="10"
            placeholder="Type or paste your text here..."
            value={text}
            onChange={(e) => setText(e.target.value)}
          />

          <div className="mt-4">
            <h5>Results:</h5>
            <ul className="list-group">
              <li className="list-group-item">Words: {countWords(text)}</li>
              <li className="list-group-item">Characters (with spaces): {countChars(text)}</li>
              <li className="list-group-item">Characters (without spaces): {countCharsNoSpaces(text)}</li>
              <li className="list-group-item">Sentences: {countSentences(text)}</li>
              <li className="list-group-item">Paragraphs: {countParagraphs(text)}</li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}
